<script>
export default {
    components: {},
    props: {
        modelValue: [String, Object, Number],
        name: String,
        readonly: Boolean,
        options: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: [{ text: null, value: null }],
        },
        placeholder: {
            type: String,
            default: '',
        },
        wFull: Boolean,
        hFull: Boolean,
        width14: Boolean,
        width20: Boolean,
        width24: Boolean,
        width36: Boolean,
        width40: Boolean,
        width44: Boolean,
        width52: Boolean,
        width60: Boolean,
        width72: Boolean,
        widthCustom:{type:String, default: ''},
        height10: Boolean,
        height11: Boolean,
        height12: Boolean,
        height32: Boolean,
        height36: Boolean,
        height44: Boolean,
        optionClickEvent: Boolean,
        hasSearchButton: Boolean,
        buttonClassProps : {
            type : String,
            default : 'w-[4rem] h-[2.25rem] text-primary-3 font-body-sm-regular'
        },
        btnColorGray: Boolean,
    },
    emits: ['change', 'update:modelValue', 'searchEvent'],
    data() {
        return {
            showOptions: false,
            selectText: null,
            inputValue: null,
            selected: null,
        };
    },
    computed: {
        filteredOptions() {
            const self = this;
            if (!self.showOptions) {
                return [];
            }

            return this.options.filter(() => this.inputValue).filter((option) => option.text?.toLowerCase().includes(this.inputValue.toLowerCase()));
        },
    },
    watch: {
        modelValue(newVal){
            this.inputValue=newVal;
        }
    },
    methods: {
        onInput(event) {
            const self = this;
            self.showOptions = event.target.value == null || event.target.value == '' ? false : true;

            self.inputValue = event.target.value;

            self.$emit('update:modelValue', self.inputValue);
        },
        setInputText(value = null) {
            const self = this;
            self.inputValue = value;

            self.$emit('update:modelValue', self.inputValue);
        },
        selectOption(option) {
            const self = this;
            self.inputValue = option.text;
            self.showOptions = false;

            self.$emit('update:modelValue', self.inputValue, option);
            if (self.optionClickEvent) {
                self.searchEvent();
            }
        },
        searchEvent() {
            const self = this;
            self.showOptions = false;

            self.$emit('searchEvent');
        },
        getSearchedText() {
            const self = this;
            return self.inputValue;
        },
        getSearchedValues() {
            const self = this;
            console.log( self.inputValue)
            if (self.inputValue == null || self.inputValue == '' ) {
                return null;
            }
            if (self.options[0].text == null && self.options.length==1){
                return self.inputValue;
            }

            return self.options.filter((option) => option.text.toLowerCase().includes(this.inputValue.toLowerCase())).map((option) => option.value);
        },
    },
    mounted() {},
};
</script>

<template>
    <div class="relative">
        <div class="border border-basic-2 rounded-2 w-full h-full flex justify-start overflow-hidden">
            <input
                type="text"
                v-model="inputValue"
                @keyup.enter="searchEvent"
                @input="onInput"
                @focusin="showOptions = true"
                @focusout="showOptions = false"
                class="border-0 p-2 text-left cursor-default max-w-6xl focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 font-body-sm-regular"
                :class="[{
                    'w-96': !wFull && !width14 && !width20 && !width24 && !width36 && !width44 && !width52 && !width60 && !width72 && !widthCustom,
                    'w-full': wFull,
                    'w-14': width14,
                    'w-20': width20,
                    'w-24': width24,
                    'w-36': width36,
                    'w-44': width44,
                    'w-52': width52,
                    'w-60': width60,
                    'w-72': width72,
                    'h-full': hFull,
                    'h-[2rem]': height32,
                    'h-[2.25rem]': height36,
                    'h-[2.75rem]': height44,
                    'bg-background-basic-3': readonly,
                },
                widthCustom ]"
                :placeholder="placeholder" />
                <div class="block w-[1px] h-[2.25rem] bg-border-basic-2"></div>
            <button v-if="hasSearchButton" class=""
                    :class="[{
                        'bg-background-basic-2=': btnColorGray,
                    },
                    buttonClassProps ]" @click="searchEvent">Search</button>
        </div>
        <ul
            v-if="filteredOptions.length"
            class="border border-t-0 bg-white rounded-md absolute z-50"
            :class="{
                'w-96': !wFull && !width14 && !width20 && !width24 && !width36 && !width40 && !width52 && !width60 && !width72,
                'w-full': wFull,
                'w-14': width14,
                'w-20': width20,
                'w-24': width24,
                'w-36': width36,
                'w-40': width40,
                'w-52': width52,
                'w-60': width60,
                'w-72': width72,
                'bg-background-basic-3': readonly,
            }">
            <li v-for="option in filteredOptions" :key="option.text" @mousedown="selectOption(option)" class="p-2 hover:bg-background-baic-4 cursor-pointer">
                {{ option.text }}
            </li>
        </ul>
    </div>
</template>
